module.exports = __webpack_public_path__ + "static/media/resize.3f9c9057.png";